/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import type { Orientation } from '@visx/axis';
import { Axis as AxisCore, type AxisScale, type SharedAxisProps, } from '@visx/axis';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { type ContextValue, type SlotProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import type { StyleOrFunction } from '../../types';
import { resolveComponentStyle } from '../../utils/resolve-component-style/resolve-component-style.util';


interface AxisProps<T extends AxisScale> extends Pick<Partial<SharedAxisProps<T>>, 'scale' | 'tickFormat' | 'tickValues' | 'numTicks' | 'left' | 'top'>, SlotProps {
  withoutAxisLine?: boolean;
  tickLabelAngle?: number;
  style?: stylex.StyleXStyles | {
    base?: stylex.StyleXStyles;
    label?: StyleOrFunction<T>;
  };
}

const AxisContext = createContext<ContextValue<AxisProps<AxisScale>, SVGGElement>>({});

const Axis = forwardRef<SVGGElement, AxisProps<AxisScale>>((props, ref) => {
  [props, ref] = useContextProps(props, ref, AxisContext);

  const { style, scale, slot, withoutAxisLine = false, tickLabelAngle, ...coreProps } = props;

  return (
    <AxisCore
      innerRef={ref}
      scale={scale!}
      hideAxisLine={withoutAxisLine}
      orientation={slot as keyof typeof Orientation}
      axisLineClassName={stylex.props(styles.base, resolveComponentStyle(style, {} as AxisScale, 'base')).className}
      hideTicks
      tickLength={8}
      tickLabelProps={{
        ...slot === AXIS_SLOTS.LEFT || slot === AXIS_SLOTS.RIGHT ? { dy: '4px' } : {},
        ...(tickLabelAngle != null && (slot === AXIS_SLOTS.TOP || slot === AXIS_SLOTS.BOTTOM) ? { angle: tickLabelAngle } : null),
        ...stylex.props(tickStyles.base, tickStyles[slot as keyof typeof Orientation], resolveComponentStyle(style, {} as AxisScale, 'label'))
      }}
      {...coreProps}
    />
  );
}) as <T extends AxisScale>(props: AxisProps<T> & { ref?: ForwardedRef<SVGGElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    stroke: $.border06,
    strokeWidth: 1,
  },
});

const tickStyles = stylex.create({
  base: {
    fill: $.textQuaternary,
    fontFamily: 'Inter',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: -0.4,
    lineHeight: 16,
  },
  left: {
    textAnchor: 'end',
  },
  right: {
    textAnchor: 'start',
  },
  bottom: {},
  top: {}
});

const AXIS_SLOTS = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
} as const;

export { AXIS_SLOTS, Axis, AxisContext, type AxisProps };
